module.exports = __webpack_public_path__ + "img/back-arrow.a70e7f9e.svg";